// The admin works on one product at a time; every screen scopes to it.
export type ProductLine = "POSTERMAKER" | "DRAWPOST_ADS";

export const PRODUCT_LINES: readonly ProductLine[] = ["DRAWPOST_ADS", "POSTERMAKER"];

export const DEFAULT_PRODUCT: ProductLine = "DRAWPOST_ADS";

/** Users-only admins work on DrawPost and cannot switch. */
export const RESTRICTED_ADMIN_PRODUCT: ProductLine = "DRAWPOST_ADS";

export const PRODUCT_LABEL: Record<ProductLine, string> = {
  POSTERMAKER: "Postermaker",
  DRAWPOST_ADS: "DrawPost Ads",
};

export const isProductLine = (value: unknown): value is ProductLine =>
  PRODUCT_LINES.includes(value as ProductLine);

export type AdminSection = "dashboard" | "templates" | "users" | "userDetails" | "billing";

const SECTIONS: Record<ProductLine, ReadonlySet<AdminSection>> = {
  POSTERMAKER: new Set<AdminSection>(["dashboard", "templates", "users", "billing"]),
  DRAWPOST_ADS: new Set<AdminSection>(["users", "userDetails", "billing"]),
};

export const hasSection = (product: ProductLine, section: AdminSection): boolean =>
  SECTIONS[product].has(section);

/** Where the admin lands: the Dashboard when the product has one, else Users. */
export const homePath = (product: ProductLine): string => (hasSection(product, "dashboard") ? "/" : "/users");

/** The product in effect: restricted admins are locked; otherwise the saved choice, if valid. */
export const resolveProduct = (saved: string | null, restricted: boolean): ProductLine => {
  if (restricted) return RESTRICTED_ADMIN_PRODUCT;
  return isProductLine(saved) ? saved : DEFAULT_PRODUCT;
};
